/**
 * Product description tabs section.
 *
 * Importing the SCSS here makes Vite bundle the section's CSS alongside its
 * JS. Implements the WAI-ARIA tabs pattern: click or arrow keys switch panels.
 */

import './index.scss';

const sections = document.querySelectorAll('[data-product-tabs]');

sections.forEach((section) => {
	const tabs = Array.from(section.querySelectorAll('[data-product-tabs-tab]'));
	const panels = Array.from(section.querySelectorAll('[data-product-tabs-panel]'));

	if (!tabs.length) return;

	const activate = (index) => {
		tabs.forEach((tab, tabIndex) => {
			const isActive = tabIndex === index;
			tab.setAttribute('aria-selected', String(isActive));
			tab.setAttribute('tabindex', isActive ? '0' : '-1');
			panels[tabIndex].hidden = !isActive;
		});
		tabs[index].focus();
	};

	tabs.forEach((tab, index) => {
		tab.addEventListener('click', () => activate(index));

		tab.addEventListener('keydown', (event) => {
			const lastIndex = tabs.length - 1;
			let targetIndex = null;

			if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
				targetIndex = index === lastIndex ? 0 : index + 1;
			} else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
				targetIndex = index === 0 ? lastIndex : index - 1;
			} else if (event.key === 'Home') {
				targetIndex = 0;
			} else if (event.key === 'End') {
				targetIndex = lastIndex;
			}

			if (targetIndex !== null) {
				event.preventDefault();
				activate(targetIndex);
			}
		});
	});
});
